import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const comingSoonBadgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80 gap-1',
  {
    variants: {
      size: {
        default: 'text-xs',
        sm: 'text-[10px] px-2 py-0.5',
        xs: 'text-[10px] px-1.5 py-0.5',
        xxs: 'text-[10px] px-1 py-0.5',
        lg: 'text-sm px-3 py-1',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  }
);

export interface ComingSoonBadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof comingSoonBadgeVariants> {}

function ComingSoonBadge({ className, size, ...props }: ComingSoonBadgeProps) {
  return (
    <div
      className={cn(comingSoonBadgeVariants({ size }), className)}
      {...props}
    >
      <span>Coming Soon</span>
      <span>✨</span>
    </div>
  );
}

export { ComingSoonBadge, comingSoonBadgeVariants };
